"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fieldset = void 0;
const tsx = __importStar(require("vue-tsx-support"));
const constants = __importStar(require("@/components/Form/constants"));
const utils = __importStar(require("@/utils"));
const Description_1 = require("../Description");
const shared_1 = require("./shared");
exports.Fieldset = tsx.component({
    name: constants.nameFieldset,
    props: shared_1.commonProps,
    computed: {
        childrenContainerClasses() {
            return [
                'flex flex-col',
                {
                    default: 'gap-1',
                    'card-like': [
                        'rounded overflow-hidden',
                        'bg-white dark:bg-neutral-60',
                        'border-neutral-5 divide-y divide-neutral-5 dark:divide-neutral-80',
                    ],
                    quiz: ['gap-y-3'],
                }[this.variant],
                this.optionsWrapperClasses,
            ];
        },
    },
    render() {
        return (<fieldset data-cy={constants.nameFieldset} class={[constants.nameField, constants.nameFieldset, 'group']} disabled={this.disabled}>
                
                <legend class="contents">
                    <span class={[
                constants.nameLabel,
                'label-large',
                'self-start',
                {
                    'mt-1': this.variant === 'default',
                    'mt-2': this.variant === 'card-like',
                    'sr-only': this.variant === 'quiz',
                },
                this.legendClasses,
            ]}>
                        {this.legend}
                    </span>
                    {utils.ifOrEmpty(this.description != null, () => (<Description_1.Description>{this.description}</Description_1.Description>))}
                </legend>
                <div class={this.childrenContainerClasses}>{this.$slots.default}</div>
            </fieldset>);
    },
});
